import { createSelector } from 'reselect';
import { AlarmColorType, AlarmDetailsExpandedState, AlarmModel, AlarmNote, AlarmNoteForAcknowledge } from '../../model/AlarmModel';

import { RootReducer } from '../../store/rootReducer';

export const selectShowAlarmDetails = createSelector(
	(state: RootReducer) => state.alarmReducer.showAlarmDetails,
	(showAlarmDetails: boolean) => showAlarmDetails
);

export const selectShowAlarmCredentials = createSelector(
	[(state: RootReducer) => state.alarmReducer.showCredentials, (state: RootReducer) => state.alarmReducer.credentialsIds],
	(showCredentials: boolean, credentialsIds: number[]) => ({ showCredentials, credentialsIds })
);

export const selectAlarmDetailsForModal = createSelector(
	[(state: RootReducer) => state.alarmReducer.alarmModel, (state: RootReducer) => state.alarmReducer.showAlarmDetailsExpandedState],
	(alarmModel: Partial<AlarmModel>, showAlarmDetailsExpandedState: AlarmDetailsExpandedState) => ({ alarmModel, showAlarmDetailsExpandedState })
);

export const selectShowAddOperatorNote = createSelector(
	(state: RootReducer) => state.alarmReducer.showAddOperatorNote,
	(showAddOperatorNote: boolean) => showAddOperatorNote
);

export const selectAlarmNoteForAcknowledge = createSelector(
	(state: RootReducer) => state.alarmReducer.alarmNoteForAcknowledge,
	(alarmNoteForAcknowledge: AlarmNoteForAcknowledge) => alarmNoteForAcknowledge
);

export const selectOperatorNotesAdded = createSelector(
	(state: RootReducer) => state.alarmReducer.operatorNoteAdded,
	(operatorNotesAdded: AlarmNote[]) => operatorNotesAdded
);

export const selectAlarmColors = createSelector(
	(state: RootReducer) => state.alarmReducer.alarmColors,
	(alarmColors: Record<AlarmColorType, string>) => alarmColors
);
